"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const analytics_1 = require("../../utils/analytics");
const defaultProps = {
    style: null,
    disabled: false,
};
const Pressable = ({ children, disabled, onPress, style, eventName }) => {
    const onPressHandler = () => {
        analytics_1.logEvent(eventName);
        onPress();
    };
    return (react_1.default.createElement(react_native_1.Pressable, { onPress: onPressHandler, style: style, disabled: disabled }, children));
};
Pressable.defaultProps = defaultProps;
exports.default = Pressable;
